import { ExploreRouterLike } from "@/views/viz/open-explore";

function withBasePath(path: string): string {
    const basePath = process.env.BASE_URL || "/";
    const normalizedBasePath = basePath.endsWith("/") ? basePath.slice(0, -1) : basePath;
    return `${window.location.origin}${normalizedBasePath}${path}`;
}

export { withBasePath };

export function createEmbedRouter(): ExploreRouterLike {
    return {
        resolve(to) {
            if (to.name === "exploreShortBookmark" && to.query?.v) {
                return { href: withBasePath(`/viz?v=${encodeURIComponent(to.query.v)}`) };
            }
            return { href: withBasePath("/") };
        },
    };
}
